/**
 * Seccion colapsable del sidebar que contiene un titulo y una lista de enlaces.
 * Utiliza el componente StyleClass de PrimeReact para manejar la animacion de apertura y cierre.
 * 
 */

import React, { useRef } from 'react';
import { StyleClass } from 'primereact/styleclass';
import SidebarLink from './sidebar-link';

const SidebarSection = ({ title, items, onSelect  }) => {
  const ref = useRef(null);

  return (
    <div className="px-0">
      <StyleClass nodeRef={ref} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
        <div ref={ref} className="p-3 flex align-items-center justify-content-between text-600 cursor-pointer">
          <span className="font-medium">{title}</span>
          <i className="pi pi-chevron-down"></i>
        </div>
      </StyleClass>
      <ul className="list-none m-0 p-0 overflow-hidden">
        {items.map((item, idx) => (
          <SidebarLink key={idx} {...item} onSelect={onSelect}/>
        ))}
      </ul>
    </div>
  );
};

export default SidebarSection;
